
import _template from "lodash/template"

import I18n from "plugins/i18n-js"

import Modal from "app/modal/show-modal"

import modal from "./modal.html._tpl"
const modal_tmpl_func = _template(modal)

function show() {
  const modal_html: string = modal_tmpl_func({
    heading_text:     I18n.t("apps_spacious_website_components.listing_search.listing_search_creation_failure_message_modal_4_record_with_same_criteria_exist.heading_text"),
    description_text: I18n.t("apps_spacious_website_components.listing_search.listing_search_creation_failure_message_modal_4_record_with_same_criteria_exist.description_text"),
  })

  Modal.showModalWithContent(modal_html)
}

export default {
  show,
}

export {
  show,
}
